var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    "data-name": "Vrstva 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.13 42.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.2,2.69l-2-2.54A.39.39,0,0,0,49.7.06l-2.08,1.3a.28.28,0,0,0-.12.31.45.45,0,0,1-.19.52L21.36,20.74a.55.55,0,0,1-.83-.24l-1.38-3.29a.28.28,0,0,0-.36-.15l-1.2.51a.27.27,0,0,0-.14.36l1.85,4.48a.33.33,0,0,1-.11.38L2,36.1A7.33,7.33,0,0,0,.18,38.26a1.86,1.86,0,0,0,0,1.67h0a.89.89,0,0,0,.71.4l25.24.92a1.73,1.73,0,0,0,.3.41L26.2,42a.3.3,0,0,0,0,.37.31.31,0,0,0,.5,0L27,42a1.79,1.79,0,0,0,.7.15,1.71,1.71,0,0,0,1.38-.7l.36.2a.33.33,0,0,0,.38,0,.32.32,0,0,0-.06-.5l-.41-.23a1.56,1.56,0,0,0,.06-.44,1.73,1.73,0,0,0-.15-.68c1.56-2.31,16.6-28.84,18-30.62a15.93,15.93,0,0,1,2.44-2.94c.26-.23.49-.33.61-.19a.28.28,0,0,0,.35,0l2.33-1.46a.39.39,0,0,0,.13-.55ZM1,39.64a.61.61,0,1,1,0-1.21.61.61,0,1,1,0,1.21Zm23.53-.23L4,39.1A1.18,1.18,0,0,1,3.24,37L19.62,24.26a.33.33,0,0,1,.5.13l5.52,13.38A1.18,1.18,0,0,1,24.52,39.41Zm4.2,1.1a1,1,0,0,1-2-.07,1,1,0,0,1,2,.07ZM45.15,6.85c-4.81,8.6-12.77,20.86-17,29.75a.49.49,0,0,1-.89,0L21.77,23.48a1,1,0,0,1,.38-1.2L44.76,6.49A.27.27,0,0,1,45.15,6.85Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.62,
    y: 16.39,
    width: 2.54,
    height: 0.74,
    transform: "translate(-5.21 8.55) rotate(-23.56)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.cd04e29bb673f77389e5cd8e6da5414b.svg";
export { ForwardRef as ReactComponent };